export const TRUE = 'true';

export type ToggleableStateKeptInSessionCtor = (new () => object) & {
	isActive: boolean;
	toggle: () => void;
	toggleAndReloadPage: () => void;
	set: (state: boolean) => void;
	setAndReloadPage: (state: boolean) => void;
};

export function toggleableStateKeptInSessionStorageFactory(sessionStorageKey: string): ToggleableStateKeptInSessionCtor {

	class ToggleableStateKeptInSessionStorage {

		protected static get _storage(): Storage {
			return sessionStorage;
		}

		static get isActive(): boolean {
			try {
				return this._storage.getItem(sessionStorageKey) === TRUE;
			} catch {
				return false;
			}
		}

		static toggle(): void {
			this._setState(null, false);
		}

		static toggleAndReloadPage(): void {
			this._setState(null, true);
		}

		static set(state: boolean): void {
			this._setState(state, false);
		}

		static setAndReloadPage(state: boolean): void {
			this._setState(state, true);
		}

		private static _setState(state: boolean | null, reloadPage: boolean): void {
			const nextIsActiveState = state ?? !this.isActive;

			if (nextIsActiveState === this.isActive)
				return;

			try {
				nextIsActiveState
					? this._storage.setItem(sessionStorageKey, TRUE)
					: this._storage.setItem(sessionStorageKey, 'false');
			} catch {
				// ignore
			}

			reloadPage && globalThis.location.reload();
		}

	}

	return ToggleableStateKeptInSessionStorage;
}
